import currencyFormatter from 'common/currencyFormatter';
import dateUtility from 'common/DateUtility';
import { InvoiceType } from 'common/constants';

let CsvDataGenerator = {};

CsvDataGenerator.generateCSVData = (invoices, unpaidOnly, invoiceType) => {
    
    if(unpaidOnly) {
        invoices = invoices.filter( invoice => {
            return invoice.invoiceTotal > invoice.postedToReceivables
        });
    }
    return invoices.map( invoice => {
        invoice.paid = invoice.postedToReceivables >= invoice.invoiceTotal ? "YES" : "NO"
        invoice.credits = currencyFormatter.formatUSD(invoice.credits);
        invoice.invoiceTotal = currencyFormatter.formatUSD(invoice.invoiceTotal);
        invoice.dateTowed = dateUtility.dateToString(invoice.dateTowed);
        invoice.date = dateUtility.dateToString(invoice.date);
        invoice.paymentDate = dateUtility.dateToString(invoice.paymentDate);
        if (typeof invoice.serviceNotes === "string") {
            invoice.serviceNotes = invoice.serviceNotes.replace(/"/g, '""');
        }
        invoice.customerAddress = formatAddress(invoice);
        
        if(invoiceType === InvoiceType.TOW) {
            invoice.number = "T" + invoice.number;
        } else if(invoiceType === InvoiceType.LOAD) {
            invoice.id = "L" + invoice.id;
        } else {
            invoice.id = "S" + invoice.id;
        }
        return invoice;
    });
};

function formatAddress (invoice) {
    const street = invoice.street ? invoice.street + ', ' : "";
    const city = invoice.city ?  invoice.city + ', ' : "";
    var zipcode = invoice.zipcode ? ' ' + invoice.zipcode : "";
    
    // remove the dangling -
    if(zipcode && zipcode.length > 0) {
        if(zipcode.charAt(zipcode.length - 1) === '-'  || zipcode.includes('-    '))  {
            zipcode = zipcode.substring(0, 6);
        }
    }
    if(invoice.state === null) {
        invoice.state = '';
    }
    return street + city + invoice.state + zipcode;
}

CsvDataGenerator.generateHeaders = (invoiceType) => {
    const actionKey = InvoiceType.actionKey(invoiceType);
    const invoiceIdKey = InvoiceType.invoiceIdKey(invoiceType);

    var headers = [
        { label: "Customer", key: "name" },
        { label: "Date", key: actionKey },
        { label: "Payment Date", key: "paymentDate" },
        { label: "Unit", key: "unit" },
        { label: "Invoice Number", key: invoiceIdKey },
        { label: "Invoice Total", key: "invoiceTotal" },
        { label: "Paid", key: "paid" },
        { label: "Company PO", key: "companyPO" },
        { label: "Customer Address", key: "customerAddress" },
        { label: "Service Notes", key: "serviceNotes" },
    ];

    if(invoiceType === InvoiceType.TOW) {
        headers.push({ label: "Tow Vehicle", key: "towVehicle" });
    }

    return headers;
}

export default CsvDataGenerator;